import React, { Component } from "react";
import { Link } from "react-router-dom";
import { connect } from "react-redux";

import { SEARCH_ARTICLE } from "../../actions/types";

import HelpAndSupportHeader from "../CommonComponents/HelpAndSupportHeader";
import ErrorMessage from "../CommonComponents/ErrorMessage";
import clear from "../../svg/cancel_small.svg";

import api from "../../api/api";

class HelpSearch extends Component {
  constructor(props) {
    super(props);
    this.state = {
      searchResult: [],
      clearBtn: false,
      displayErrorPopup: false,
      searchKeyword: this.props.searchResults.searchKeyword,
      curr_page: this.props.searchResults.curr_page,
      scrolling: false,
      loading: false
    };
    this.searchTypedKeyword = this.searchTypedKeyword.bind(this);
  }

  /**
   * this is for history or goback
   * and reset the search values
   */
  goBack = () => {
    let resetSearch = {
      searchResultArray: [],
      searchKeyword: "",
      next_page: null,
      curr_page: 1
    };
    this.props.searchArticles(resetSearch);
    this.props.history.goBack();
  };

  /**
   * this is to set the value of the input box,
   * for the visible of search icon and
   * calls the method searchTypedKeyword() for search
   * it also triggres the dispatcher using method this.props.searchArticles to reset any search result
   */
  searchForHelp(event) {
    this.setState(
      {
        searchKeyword: event.target.value,
        curr_page: 1
      },
      () => {
        if (this.state.searchKeyword.length > 0) {
          this.setState({
            clearBtn: true
          });
        } else {
          this.setState({
            clearBtn: false
          });
        }
        if (this.state.searchKeyword.length > 3) {
          this.searchTypedKeyword();
        } else {
          this.setState({
            searchResult: [],
            next_page: null
          });
          let dataToSend = {
            searchResultArray: [],
            searchKeyword: ""
          };
          this.props.searchArticles(dataToSend);
        }
      }
    );
  }
  /**
   * calls searchBasedOnCategory method that does the api call for the typed keyword
   * on the result the dispatcher is triggred using method this.props.searchArticles
   */
  searchTypedKeyword() {
    this.setState({ loading: true });
    const { categoryId } = this.props;
    if (categoryId) {
      api
        .searchBasedOnCategory(this.state.searchKeyword, this.state.curr_page, categoryId)
        .then(data => {
          let dataToSend = {
            searchResultArray: data.data,
            searchKeyword: this.state.searchKeyword,
            // next_page: data.data.next_page,
            // curr_page: this.state.curr_page + 1
          };
          this.props.searchArticles(dataToSend);
          this.setState({
            scrolling: false,
            loading: false,
            curr_page: dataToSend.curr_page
          });
        })
        .catch(error => {
          this.setState({
            displayErrorPopup: true
          });
          console.log(error);
        });
    }
  }

  /**
   * sets the search keyword to empty and hides the clear btn
   * it also clear the store data containing the search result
   */
  clearBtnClick = () => {
    let dataToSend = {
      searchResultArray: [],
      searchKeyword: "",
      next_page: null,
      curr_page: 1
    };
    this.props.searchArticles(dataToSend);
    this.setState({
      searchKeyword: "",
      clearBtn: false,
      scrolling: false,
      curr_page: 1
    });
  };

  /**
   * close the error popup
   */
  errorCloseCLick = () => {
    this.setState({
      displayErrorPopup: false
    });
  };

  /**
   * updates the state for the load of next page
   */
  loadMoreSearchResults = () => {
    this.setState(
      {
        curr_page: this.state.curr_page + 1,
        scrolling: true
      },
      () => {
        this.searchForHelp();
      }
    );
  };

  /**
   * this method is triggered when loading starts and checks is it end of page or not
   * if end of page then loads more data if it has next page
   */
  handleScroll = () => {
    const scrolling = this.state.scrolling;
    const totalPage = this.props.searchResults.next_page;

    if (scrolling) {
      return;
    }

    if (totalPage === null) {
      return;
    }

    const secondLastElement = document.querySelector(".search-result-link:nth-last-child(2)");
    const lastOffset = secondLastElement.offsetTop + secondLastElement.clientHeight;
    const pageOffset = window.pageYOffset + window.innerHeight;
    const bottomOffset = 50;
    if (pageOffset > lastOffset - bottomOffset) {
      this.loadMoreSearchResults();
    }
  };

  componentDidMount() {
    api.displayHideLoader();
    window.addEventListener("scroll", this.handleScroll);
    document.getElementById("searchBox").focus();
  }
  componentWillUnmount() {
    window.removeEventListener("scroll", this.handleScroll);
  }

  render() {
    const { searchResultArray } = this.props.searchResults;
    const { searchKeyword, loading } = this.state;
    const noResults = searchKeyword.length > 3 && searchResultArray.length < 1;
    return (
      <div>
        {this.state.displayErrorPopup ? <ErrorMessage onCloseClick={this.errorCloseCLick.bind(this)} /> : ""}
        <HelpAndSupportHeader displayMessage={this.props.headerMessage} back={this.goBack.bind(this)} />
        <div className="body-container">
          <div className="search-box-container">
            <div className="search-box">
              <div className="search-box-title">SEARCH</div>
              <input
                type="text"
                id="searchBox"
                value={this.state.searchKeyword}
                className="search-box-input"
                ref={input => {
                  this.searchBar = input;
                }}
                onChange={this.searchForHelp.bind(this)}
                placeholder="Keyword"
              />
            </div>
            <div className="">
              {this.state.clearBtn ? (
                <img className="search-box-clear" src={clear} alt="" onClick={this.clearBtnClick.bind(this)} />
              ) : (
                ""
              )}
            </div>
          </div>
          <div className="search-results-container">
            {this.props.searchResults.searchResultArray.map(result => {
              return <TopicLink resultData={result} key={result.id} />;
            })}
            {noResults && !loading ? <div className="no-results">No Results Found</div> : null}
          </div>
        </div>
      </div>
    );
  }
}

const TopicLink = props => {
  return (
    <Link to={"/articledetails/" + props.resultData.id} className="search-result-link">
      {props.resultData.title}
    </Link>
  );
};

const mapStateToProps = state => {
  return {
    headerMessage: {
      title: "",
      description: "",
      backIcon: false,
      moreOptionhidden: true,
      searchOptionHidden: true
    },
    searchResults: state.searchResults,
    categoryId: state.categoryId
  };
};
const mapDispatchToProps = dispatch => {
  return {
    searchArticles: articleList => {
      dispatch({
        type: SEARCH_ARTICLE,
        payload: articleList
      });
    }
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(HelpSearch);



// WEBPACK FOOTER //
// ./src/components/Search/HelpSearch.js